import UserNavbar from './UserNavbar';

const navbarComponents = { UserNavbar };

export { UserNavbar };
export default navbarComponents;
